// common configuration
const config = {
    api: {
        baseUrl: "https://nabidky.treserviselektro.cz/api"
    },
    afterLoginRoute: "calculations",
    vueAppUrl: "https://nabidky.treserviselektro.cz"
};

if (import.meta.env.VITE_VUE_APP_SERVER == "production") {
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_matej") {
    config["vueAppUrl"] = "http://localhost:10050";
    config["api"]["baseUrl"] = "http://localhost:10051";
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_michal") {
    config["vueAppUrl"] = "http://localhost:35001";
    config["api"]["baseUrl"] = "http://localhost:35000";
}

export const CONFIG = config;